module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/estimate_1-26d386197f48c763fc40a1632d84a84b.jpg";